import DataTableGrid from '@bumble/app/components/DataTableGrid';
import { Loading } from '@bumble/app/components/Loading';
import TimeRange from '@bumble/app/components/TimeRange';
import { TIME_BUTTONS } from '@bumble/app/constants';
import { useApi } from '@bumble/app/hooks/use-api';
import { GridColDef } from '@mui/x-data-grid';
import { useQuery } from '@tanstack/react-query';
import { DateTime, Duration, DurationLikeObject } from 'luxon';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

type EpSessions = {
  "start_time": string,
  "end_time": string,
  "src_addr": string,
  "src_port": number,
  "dst_addr": string,
  "dst_port": number,
  "proto": number,
  "tx_bytes": number,
  "tx_packets": number,
  "rx_bytes": number,
  "ep_id": string,
  "app_service_id": string,
  "node_id": string,
};

interface EndpointTabFlowsProps {
  id: string;
}
export const EndpointTabFlows = ({ id }: EndpointTabFlowsProps) => {
  const api = useApi();
  const [timeRange, setTimeRange] = useState<DurationLikeObject>(TIME_BUTTONS[0].value);
  const hours = parseInt(Duration.fromObject(timeRange).toFormat('h'), 10);
  const columns: GridColDef[] = [
    {
      field: 'start_time',
      headerName: 'Start Time',
      width: 300,
      //disableColumnMenu: true,
      //valueGetter: (params) => {
      //  if (params.value === null) return '';
      //  return getChartTime(params.value, hours);
      // return DateTime.fromMillis(params.value).toLocaleString(DateTime.DATETIME_SHORT);
      //}
    },
    {
      field: 'end_time',
      headerName: 'End Time',
      width: 300,
      //disableColumnMenu: true,
      //valueGetter: (params) => {
      //  if (params.value === null) return '';
      //  return getChartTime(params.value, hours);
      // return DateTime.fromMillis(params.value).toLocaleString(DateTime.DATETIME_SHORT);
      //}
    },
    //{
    //  field: 'node_id',
    //  headerName: 'Node Id',
    //  width: 200,
    //  disableColumnMenu: true,
    //},
    //{
    //  field: 'ep_id',
    //  headerName: 'EP Id',
    //  width: 200,
    //  disableColumnMenu: true,
    //},
    //{
    //  field: 'app_service_id',
    //  headerName: 'App Service Id',
    //  width: 200,
    //  disableColumnMenu: true,
    //},
    {
      field: 'src_addr',
      headerName: 'IP-1',
      flex: 1,
      minWidth: 100,
      //disableColumnMenu: true,
    },
    {
      field: 'dst_addr',
      headerName: 'IP-2',
      flex: 1,
      minWidth: 100,
      //disableColumnMenu: true,
    },
    {
      field: 'src_port',
      headerName: 'IP-1 Port',
      width: 100,
      //disableColumnMenu: true,
    },
    {
      field: 'dst_port',
      headerName: 'IP-2 Port',
      width: 100,
      //disableColumnMenu: true,
    },
    {
      field: 'proto',
      headerName: 'Protocol',
      width: 100,
      //disableColumnMenu: true,
    },
    {
      field: 'app_name',
      headerName: 'App Name',
      width: 250,
    },
    {
      field: 'tx_bytes',
      headerName: 'IP-1 to IP-2 Bytes',
      width: 160,
      //disableColumnMenu: true,
    },
    // {
    //   field: 'tx_packets',
    //   headerName: 'TX Packets',
    //   width: 100,
    //   disableColumnMenu: true,
    // },
    {
      field: 'rx_bytes',
      headerName: 'IP-2 to IP-1 Bytes',
      width: 160,
      //disableColumnMenu: true,
    },
  ];

  const columnVisible = {
    start_time: true,
    end_time: true,
    src_addr: true,
    src_port: true,
    dst_addr: true,
    dst_port: true,
    proto: true,
    app_name: true,
    tx_bytes: true,
    tx_packets: false,
    rx_bytes: true,
    ep_id: true,
    app_service_id: true,
    node_id: true,
  };

  const { isLoading, data, refetch } = useQuery(
    ['epSessions'],
    api.getEpSessionsApiV1GetEpSessionsGet.bind(null, {
      ep_id: id,
      start_time: DateTime.now().minus(timeRange).toISO(),
      end_time: DateTime.now().toISO(),
    }),
    { enabled: true, cacheTime: 0 },
  );

  const handleTimeChange = (e: React.MouseEvent<HTMLElement>, val: DurationLikeObject) => {
    if (val) setTimeRange(val);
  };

  useEffect(() => {
    refetch();
  }, [timeRange]);

  const handleDataRefetch = () => {
    refetch();
    toast.success('Refreshed data.');
  };

  if (isLoading) {
    return <Loading />;
  }

  return (
    <DataTableGrid
      rows={
        data?.data.map((item: EpSessions, i) => {
          return {
            ...item,
            id: `${item.ep_id}_${item.start_time}_${i}`,
          };
        }) || []
      }
      columns={columns}
      columnVisibilityModel={columnVisible}
      secondarySlot={<TimeRange
        timeValues={TIME_BUTTONS}
        selectedTime={timeRange}
        onTimeChange={handleTimeChange}
        onRefresh={handleDataRefetch}
      />}
      pagination
    />
  );
};
